class User {
  id: number;
  password: string;
  last_login: string;
  is_superuser: boolean;
  account_id: string;
  name: string;
  name_f: string;
  email: string;
  organization: string;
  organization_f: string;
  department: string;
  department_f: string;
  job_title: string;
  job_title_f: string;
  address: string;
  tel: string;
  usage_classification: string;
  purpose: string;
  registration_date: string;
  expiration_date: string;
  mail_sent_date: string;
  category: string;
  is_staff: boolean;
  is_active: boolean;

  constructor() {
    this.id = 0;
    this.password = '';
    this.last_login = '';
    this.is_superuser = false;
    this.account_id = '';
    this.name = '';
    this.name_f = '';
    this.email = '';
    this.organization = '';
    this.organization_f = '';
    this.department = '';
    this.department_f = '';
    this.job_title = '';
    this.job_title_f = '';
    this.address = '';
    this.tel = '';
    this.usage_classification = '';
    this.purpose = '';
    this.registration_date = '';
    this.expiration_date = '';
    this.mail_sent_date = '';
    this.category = '';
    this.is_staff = false;
    this.is_active = false;
  }

  load(data: any) {
    this.id = data.id;
    this.password = data.password;
    this.last_login = data.last_login;
    this.is_superuser = data.is_superuser;
    this.account_id = data.account_id;
    this.name = data.name;
    this.name_f = data.name_f;
    this.email = data.email;
    this.organization = data.organization;
    this.organization_f = data.organization_f;
    this.department = data.department;
    this.department_f = data.department_f;
    this.job_title = data.job_title;
    this.job_title_f = data.job_title_f;
    this.address = data.address;
    this.tel = data.tel;
    this.usage_classification = data.usage_classification;
    this.purpose = data.purpose;
    this.registration_date = data.registration_date;
    this.expiration_date = data.expiration_date;
    this.mail_sent_date = data.mail_sent_date;
    this.category = data.category;
    this.is_staff = data.is_staff;
    this.is_active = data.is_active;
  }

  buildFormData(): FormData {
    const data = new FormData();

    data.append('id', this.id.toString());
    data.append('password', this.password);
    data.append('last_login', this.last_login);
    data.append('is_superuser', this.is_superuser.toString());
    data.append('account_id', this.account_id);
    data.append('name', this.name);
    data.append('name_f', this.name_f);
    data.append('email', this.email);
    data.append('organization', this.organization);
    data.append('organization_f', this.organization_f);
    data.append('department', this.department);
    data.append('department_f', this.department_f);
    data.append('job_title', this.job_title);
    data.append('job_title_f', this.job_title_f);
    data.append('address', this.address);
    data.append('tel', this.tel);
    data.append('usage_classification', this.usage_classification);
    data.append('purpose', this.purpose);
    data.append('registration_date', this.registration_date);
    data.append('expiration_date', this.expiration_date);
    data.append('mail_sent_date', this.mail_sent_date);
    data.append('category', this.category);
    data.append('is_staff', this.is_staff.toString());
    data.append('is_active', this.is_active.toString());

    return data;
  }
}

export default User;
